//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AuthorizeService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    isAuthorized( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Authorize/IsAuthorized";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsAuthorized(_response);
        });
    }

    protected processIsAuthorized(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class MapService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAllPois( cancelToken?: CancelToken): Promise<PoiDto[] | null> {
        let url_ = this.baseUrl + "/api/Map/GetAllPois";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPois(_response);
        });
    }

    protected processGetAllPois(response: AxiosResponse): Promise<PoiDto[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PoiDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PoiDto[] | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PoiDto[] | null>(null as any);
    }

    getAllPoisOpt( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Map/GetAllPois";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPoisOpt(_response);
        });
    }

    protected processGetAllPoisOpt(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSearchFilterData( cancelToken?: CancelToken): Promise<SearchFilterData | null> {
        let url_ = this.baseUrl + "/api/Map/GetSearchFilterData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSearchFilterData(_response);
        });
    }

    protected processGetSearchFilterData(response: AxiosResponse): Promise<SearchFilterData | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? SearchFilterData.fromJS(resultData200) : <any>null;
            return Promise.resolve<SearchFilterData | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchFilterData | null>(null as any);
    }

    getSearchFilterDataOpt( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Map/GetSearchFilterData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSearchFilterDataOpt(_response);
        });
    }

    protected processGetSearchFilterDataOpt(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    searchPoisPinData(dto: PoiSearchDto, cancelToken?: CancelToken): Promise<PoiDto[] | null> {
        let url_ = this.baseUrl + "/api/Map/SearchPoisPinData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPoisPinData(_response);
        });
    }

    protected processSearchPoisPinData(response: AxiosResponse): Promise<PoiDto[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PoiDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PoiDto[] | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PoiDto[] | null>(null as any);
    }

    searchPoisPinDataOpt( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Map/SearchPoisPinData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPoisPinDataOpt(_response);
        });
    }

    protected processSearchPoisPinDataOpt(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    searchPoisGeneralData(dto: PoiSearchDto, cancelToken?: CancelToken): Promise<PoiExtendedDto[] | null> {
        let url_ = this.baseUrl + "/api/Map/SearchPoisGeneralData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPoisGeneralData(_response);
        });
    }

    protected processSearchPoisGeneralData(response: AxiosResponse): Promise<PoiExtendedDto[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PoiExtendedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PoiExtendedDto[] | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PoiExtendedDto[] | null>(null as any);
    }

    searchPoisGeneralDataOpt( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Map/SearchPoisGeneralData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPoisGeneralDataOpt(_response);
        });
    }

    protected processSearchPoisGeneralDataOpt(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getWastePointDetails(id: number | undefined, cancelToken?: CancelToken): Promise<WastePointDto | null> {
        let url_ = this.baseUrl + "/api/Map/GetWastePointDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWastePointDetails(_response);
        });
    }

    protected processGetWastePointDetails(response: AxiosResponse): Promise<WastePointDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WastePointDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<WastePointDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WastePointDto | null>(null as any);
    }

    getWastePointDetailsOpt( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Map/GetWastePointDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWastePointDetailsOpt(_response);
        });
    }

    protected processGetWastePointDetailsOpt(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDrsPointDetails(id: number | undefined, cancelToken?: CancelToken): Promise<DrsPointDto | null> {
        let url_ = this.baseUrl + "/api/Map/GetDrsPointDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDrsPointDetails(_response);
        });
    }

    protected processGetDrsPointDetails(response: AxiosResponse): Promise<DrsPointDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DrsPointDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<DrsPointDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DrsPointDto | null>(null as any);
    }

    getDrsPointDetailsOpt( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Map/GetDrsPointDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDrsPointDetailsOpt(_response);
        });
    }

    protected processGetDrsPointDetailsOpt(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getCustomerServicePointDetails(id: number | undefined, cancelToken?: CancelToken): Promise<CustomerServicePointDto | null> {
        let url_ = this.baseUrl + "/api/Map/GetCustomerServicePointDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerServicePointDetails(_response);
        });
    }

    protected processGetCustomerServicePointDetails(response: AxiosResponse): Promise<CustomerServicePointDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CustomerServicePointDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<CustomerServicePointDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerServicePointDto | null>(null as any);
    }

    getCustomerServicePointDetailsOpt( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Map/GetCustomerServicePointDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerServicePointDetailsOpt(_response);
        });
    }

    protected processGetCustomerServicePointDetailsOpt(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    sendFeedback(feedbackParams: FeedbackParamsDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Map/SendFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedbackParams);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendFeedback(_response);
        });
    }

    protected processSendFeedback(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    listFeedbackCategories( cancelToken?: CancelToken): Promise<FeedbackCategoryDto[] | null> {
        let url_ = this.baseUrl + "/api/Map/ListFeedbackCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListFeedbackCategories(_response);
        });
    }

    protected processListFeedbackCategories(response: AxiosResponse): Promise<FeedbackCategoryDto[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeedbackCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FeedbackCategoryDto[] | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeedbackCategoryDto[] | null>(null as any);
    }

    invalidateAllCaches( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Map/InvalidateAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvalidateAllCaches(_response);
        });
    }

    protected processInvalidateAllCaches(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    invalidateAllPois( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Map/InvalidateAllPois";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvalidateAllPois(_response);
        });
    }

    protected processInvalidateAllPois(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    invalidateCustomerServicePointTypes( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Map/InvalidateCustomerServicePointTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvalidateCustomerServicePointTypes(_response);
        });
    }

    protected processInvalidateCustomerServicePointTypes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    invalidateCustomerServicePoints( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Map/InvalidateCustomerServicePoints";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvalidateCustomerServicePoints(_response);
        });
    }

    protected processInvalidateCustomerServicePoints(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    invalidateDrsPoints( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Map/InvalidateDrsPoints";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvalidateDrsPoints(_response);
        });
    }

    protected processInvalidateDrsPoints(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    invalidateWasteCategories( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Map/InvalidateWasteCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvalidateWasteCategories(_response);
        });
    }

    protected processInvalidateWasteCategories(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    invalidateWastePointTypes( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Map/InvalidateWastePointTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvalidateWastePointTypes(_response);
        });
    }

    protected processInvalidateWastePointTypes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    invalidateWastePoints( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Map/InvalidateWastePoints";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvalidateWastePoints(_response);
        });
    }

    protected processInvalidateWastePoints(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TranslationService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAllTranslations( cancelToken?: CancelToken): Promise<TranslationsDto | null> {
        let url_ = this.baseUrl + "/api/Translation/GetAllTranslations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTranslations(_response);
        });
    }

    protected processGetAllTranslations(response: AxiosResponse): Promise<TranslationsDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TranslationsDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<TranslationsDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationsDto | null>(null as any);
    }
}

export class PoiDto implements IPoiDto {
    id!: number;
    type!: PoiType;
    subTypes!: string[];
    coordinates?: Coordinate | undefined;

    constructor(data?: IPoiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            if (Array.isArray(_data["subTypes"])) {
                this.subTypes = [] as any;
                for (let item of _data["subTypes"])
                    this.subTypes!.push(item);
            }
            this.coordinates = _data["coordinates"] ? Coordinate.fromJS(_data["coordinates"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PoiDto {
        data = typeof data === 'object' ? data : {};
        let result = new PoiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        if (Array.isArray(this.subTypes)) {
            data["subTypes"] = [];
            for (let item of this.subTypes)
                data["subTypes"].push(item);
        }
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPoiDto {
    id: number;
    type: PoiType;
    subTypes: string[];
    coordinates?: Coordinate | undefined;
}

export enum PoiType {
    Waste = "Waste",
    Drs = "Drs",
    CustomerService = "CustomerService",
}

export class Coordinate implements ICoordinate {
    latitude!: number;
    longitude!: number;

    constructor(data?: ICoordinate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): Coordinate {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface ICoordinate {
    latitude: number;
    longitude: number;
}

export class SearchFilterData implements ISearchFilterData {
    wastePointTypes!: TypeWithIconDto[];
    categories!: WasteCategoryDto[];
    customerServiceTypes!: TypeWithIconDto[];

    constructor(data?: ISearchFilterData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wastePointTypes = [];
            this.categories = [];
            this.customerServiceTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wastePointTypes"])) {
                this.wastePointTypes = [] as any;
                for (let item of _data["wastePointTypes"])
                    this.wastePointTypes!.push(TypeWithIconDto.fromJS(item));
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(WasteCategoryDto.fromJS(item));
            }
            if (Array.isArray(_data["customerServiceTypes"])) {
                this.customerServiceTypes = [] as any;
                for (let item of _data["customerServiceTypes"])
                    this.customerServiceTypes!.push(TypeWithIconDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchFilterData {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFilterData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wastePointTypes)) {
            data["wastePointTypes"] = [];
            for (let item of this.wastePointTypes)
                data["wastePointTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.customerServiceTypes)) {
            data["customerServiceTypes"] = [];
            for (let item of this.customerServiceTypes)
                data["customerServiceTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchFilterData {
    wastePointTypes: TypeWithIconDto[];
    categories: WasteCategoryDto[];
    customerServiceTypes: TypeWithIconDto[];
}

export class TypeWithIconDto implements ITypeWithIconDto {
    id!: number;
    type!: string;
    svgIcon?: string | undefined;
    isHidden!: boolean;

    constructor(data?: ITypeWithIconDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.svgIcon = _data["svgIcon"];
            this.isHidden = _data["isHidden"];
        }
    }

    static fromJS(data: any): TypeWithIconDto {
        data = typeof data === 'object' ? data : {};
        let result = new TypeWithIconDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["svgIcon"] = this.svgIcon;
        data["isHidden"] = this.isHidden;
        return data;
    }
}

export interface ITypeWithIconDto {
    id: number;
    type: string;
    svgIcon?: string | undefined;
    isHidden: boolean;
}

export class WasteCategoryDto implements IWasteCategoryDto {
    id!: number;
    name!: string;
    hakCode?: string | undefined;
    subCategories!: WasteSubCategoryDto[];

    constructor(data?: IWasteCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subCategories = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.hakCode = _data["hakCode"];
            if (Array.isArray(_data["subCategories"])) {
                this.subCategories = [] as any;
                for (let item of _data["subCategories"])
                    this.subCategories!.push(WasteSubCategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WasteCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WasteCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["hakCode"] = this.hakCode;
        if (Array.isArray(this.subCategories)) {
            data["subCategories"] = [];
            for (let item of this.subCategories)
                data["subCategories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWasteCategoryDto {
    id: number;
    name: string;
    hakCode?: string | undefined;
    subCategories: WasteSubCategoryDto[];
}

export class WasteSubCategoryDto implements IWasteSubCategoryDto {
    id!: number;
    name!: string;
    hakCode?: string | undefined;
    categoryId!: number;
    categoryName!: string;

    constructor(data?: IWasteSubCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.hakCode = _data["hakCode"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
        }
    }

    static fromJS(data: any): WasteSubCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WasteSubCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["hakCode"] = this.hakCode;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        return data;
    }
}

export interface IWasteSubCategoryDto {
    id: number;
    name: string;
    hakCode?: string | undefined;
    categoryId: number;
    categoryName: string;
}

export class PoiSearchDto implements IPoiSearchDto {
    searchInPoiTypes?: PoiType[] | undefined;
    coordinates?: Coordinate | undefined;
    location?: string | undefined;
    radiusKm?: number | undefined;
    routePolyLine?: string | undefined;
    wastePointTypes!: string[];
    wasteCategories!: string[];
    rpoId?: string | undefined;
    pocId?: string | undefined;
    upi?: string | undefined;
    isManualPoint?: boolean | undefined;
    isAutomaticPoint?: boolean | undefined;
    customerServiceTypes!: string[];

    constructor(data?: IPoiSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wastePointTypes = [];
            this.wasteCategories = [];
            this.customerServiceTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["searchInPoiTypes"])) {
                this.searchInPoiTypes = [] as any;
                for (let item of _data["searchInPoiTypes"])
                    this.searchInPoiTypes!.push(item);
            }
            this.coordinates = _data["coordinates"] ? Coordinate.fromJS(_data["coordinates"]) : <any>undefined;
            this.location = _data["location"];
            this.radiusKm = _data["radiusKm"];
            this.routePolyLine = _data["routePolyLine"];
            if (Array.isArray(_data["wastePointTypes"])) {
                this.wastePointTypes = [] as any;
                for (let item of _data["wastePointTypes"])
                    this.wastePointTypes!.push(item);
            }
            if (Array.isArray(_data["wasteCategories"])) {
                this.wasteCategories = [] as any;
                for (let item of _data["wasteCategories"])
                    this.wasteCategories!.push(item);
            }
            this.rpoId = _data["rpoId"];
            this.pocId = _data["pocId"];
            this.upi = _data["upi"];
            this.isManualPoint = _data["isManualPoint"];
            this.isAutomaticPoint = _data["isAutomaticPoint"];
            if (Array.isArray(_data["customerServiceTypes"])) {
                this.customerServiceTypes = [] as any;
                for (let item of _data["customerServiceTypes"])
                    this.customerServiceTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): PoiSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PoiSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchInPoiTypes)) {
            data["searchInPoiTypes"] = [];
            for (let item of this.searchInPoiTypes)
                data["searchInPoiTypes"].push(item);
        }
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["location"] = this.location;
        data["radiusKm"] = this.radiusKm;
        data["routePolyLine"] = this.routePolyLine;
        if (Array.isArray(this.wastePointTypes)) {
            data["wastePointTypes"] = [];
            for (let item of this.wastePointTypes)
                data["wastePointTypes"].push(item);
        }
        if (Array.isArray(this.wasteCategories)) {
            data["wasteCategories"] = [];
            for (let item of this.wasteCategories)
                data["wasteCategories"].push(item);
        }
        data["rpoId"] = this.rpoId;
        data["pocId"] = this.pocId;
        data["upi"] = this.upi;
        data["isManualPoint"] = this.isManualPoint;
        data["isAutomaticPoint"] = this.isAutomaticPoint;
        if (Array.isArray(this.customerServiceTypes)) {
            data["customerServiceTypes"] = [];
            for (let item of this.customerServiceTypes)
                data["customerServiceTypes"].push(item);
        }
        return data;
    }
}

export interface IPoiSearchDto {
    searchInPoiTypes?: PoiType[] | undefined;
    coordinates?: Coordinate | undefined;
    location?: string | undefined;
    radiusKm?: number | undefined;
    routePolyLine?: string | undefined;
    wastePointTypes: string[];
    wasteCategories: string[];
    rpoId?: string | undefined;
    pocId?: string | undefined;
    upi?: string | undefined;
    isManualPoint?: boolean | undefined;
    isAutomaticPoint?: boolean | undefined;
    customerServiceTypes: string[];
}

export class PoiExtendedDto implements IPoiExtendedDto {
    id!: number;
    type!: PoiType;
    subTypes!: string[];
    coordinates?: Coordinate | undefined;
    name?: string | undefined;
    address?: string | undefined;

    constructor(data?: IPoiExtendedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            if (Array.isArray(_data["subTypes"])) {
                this.subTypes = [] as any;
                for (let item of _data["subTypes"])
                    this.subTypes!.push(item);
            }
            this.coordinates = _data["coordinates"] ? Coordinate.fromJS(_data["coordinates"]) : <any>undefined;
            this.name = _data["name"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): PoiExtendedDto {
        data = typeof data === 'object' ? data : {};
        let result = new PoiExtendedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        if (Array.isArray(this.subTypes)) {
            data["subTypes"] = [];
            for (let item of this.subTypes)
                data["subTypes"].push(item);
        }
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["address"] = this.address;
        return data;
    }
}

export interface IPoiExtendedDto {
    id: number;
    type: PoiType;
    subTypes: string[];
    coordinates?: Coordinate | undefined;
    name?: string | undefined;
    address?: string | undefined;
}

export class WastePointDto implements IWastePointDto {
    id!: number;
    name?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    normalizedPhoneNumber?: string | undefined;
    webSiteUrl?: string | undefined;
    types!: string[];
    extraMessages!: string[];
    coordinates?: Coordinate | undefined;
    wasteDetails!: WasteDetailsDto[];
    wasteTypesByCategories!: { [key: string]: { [key: string]: WasteDetailsDto[]; }; };

    constructor(data?: IWastePointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.types = [];
            this.extraMessages = [];
            this.wasteDetails = [];
            this.wasteTypesByCategories = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.normalizedPhoneNumber = _data["normalizedPhoneNumber"];
            this.webSiteUrl = _data["webSiteUrl"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            if (Array.isArray(_data["extraMessages"])) {
                this.extraMessages = [] as any;
                for (let item of _data["extraMessages"])
                    this.extraMessages!.push(item);
            }
            this.coordinates = _data["coordinates"] ? Coordinate.fromJS(_data["coordinates"]) : <any>undefined;
            if (Array.isArray(_data["wasteDetails"])) {
                this.wasteDetails = [] as any;
                for (let item of _data["wasteDetails"])
                    this.wasteDetails!.push(WasteDetailsDto.fromJS(item));
            }
            if (_data["wasteTypesByCategories"]) {
                this.wasteTypesByCategories = {} as any;
                for (let key in _data["wasteTypesByCategories"]) {
                    if (_data["wasteTypesByCategories"].hasOwnProperty(key))
                        (<any>this.wasteTypesByCategories)![key] = _data["wasteTypesByCategories"][key] !== undefined ? _data["wasteTypesByCategories"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): WastePointDto {
        data = typeof data === 'object' ? data : {};
        let result = new WastePointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["normalizedPhoneNumber"] = this.normalizedPhoneNumber;
        data["webSiteUrl"] = this.webSiteUrl;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        if (Array.isArray(this.extraMessages)) {
            data["extraMessages"] = [];
            for (let item of this.extraMessages)
                data["extraMessages"].push(item);
        }
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        if (Array.isArray(this.wasteDetails)) {
            data["wasteDetails"] = [];
            for (let item of this.wasteDetails)
                data["wasteDetails"].push(item.toJSON());
        }
        if (this.wasteTypesByCategories) {
            data["wasteTypesByCategories"] = {};
            for (let key in this.wasteTypesByCategories) {
                if (this.wasteTypesByCategories.hasOwnProperty(key))
                    (<any>data["wasteTypesByCategories"])[key] = (<any>this.wasteTypesByCategories)[key];
            }
        }
        return data;
    }
}

export interface IWastePointDto {
    id: number;
    name?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    normalizedPhoneNumber?: string | undefined;
    webSiteUrl?: string | undefined;
    types: string[];
    extraMessages: string[];
    coordinates?: Coordinate | undefined;
    wasteDetails: WasteDetailsDto[];
    wasteTypesByCategories: { [key: string]: { [key: string]: WasteDetailsDto[]; }; };
}

export class WasteDetailsDto implements IWasteDetailsDto {
    hakCode?: string | undefined;
    descriptionHU?: string | undefined;
    categoryName?: string | undefined;
    subCategoryName?: string | undefined;
    dailyMaxAmount?: string | undefined;
    yearlyMaxAmount?: string | undefined;
    compensation?: string | undefined;

    constructor(data?: IWasteDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hakCode = _data["hakCode"];
            this.descriptionHU = _data["descriptionHU"];
            this.categoryName = _data["categoryName"];
            this.subCategoryName = _data["subCategoryName"];
            this.dailyMaxAmount = _data["dailyMaxAmount"];
            this.yearlyMaxAmount = _data["yearlyMaxAmount"];
            this.compensation = _data["compensation"];
        }
    }

    static fromJS(data: any): WasteDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WasteDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hakCode"] = this.hakCode;
        data["descriptionHU"] = this.descriptionHU;
        data["categoryName"] = this.categoryName;
        data["subCategoryName"] = this.subCategoryName;
        data["dailyMaxAmount"] = this.dailyMaxAmount;
        data["yearlyMaxAmount"] = this.yearlyMaxAmount;
        data["compensation"] = this.compensation;
        return data;
    }
}

export interface IWasteDetailsDto {
    hakCode?: string | undefined;
    descriptionHU?: string | undefined;
    categoryName?: string | undefined;
    subCategoryName?: string | undefined;
    dailyMaxAmount?: string | undefined;
    yearlyMaxAmount?: string | undefined;
    compensation?: string | undefined;
}

export class DrsPointDto implements IDrsPointDto {
    id!: number;
    name?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    normalizedPhoneNumber?: string | undefined;
    webSiteUrl?: string | undefined;
    rpoId?: string | undefined;
    upi?: string | undefined;
    contractorName?: string | undefined;
    contractorAddress?: string | undefined;
    coordinates?: Coordinate | undefined;
    openTimeWeekdays?: string | undefined;
    openTimeSaturday?: string | undefined;
    openTimeSunday?: string | undefined;
    isManualPoint!: boolean;
    isAutomaticPoint!: boolean;

    constructor(data?: IDrsPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.normalizedPhoneNumber = _data["normalizedPhoneNumber"];
            this.webSiteUrl = _data["webSiteUrl"];
            this.rpoId = _data["rpoId"];
            this.upi = _data["upi"];
            this.contractorName = _data["contractorName"];
            this.contractorAddress = _data["contractorAddress"];
            this.coordinates = _data["coordinates"] ? Coordinate.fromJS(_data["coordinates"]) : <any>undefined;
            this.openTimeWeekdays = _data["openTimeWeekdays"];
            this.openTimeSaturday = _data["openTimeSaturday"];
            this.openTimeSunday = _data["openTimeSunday"];
            this.isManualPoint = _data["isManualPoint"];
            this.isAutomaticPoint = _data["isAutomaticPoint"];
        }
    }

    static fromJS(data: any): DrsPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrsPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["normalizedPhoneNumber"] = this.normalizedPhoneNumber;
        data["webSiteUrl"] = this.webSiteUrl;
        data["rpoId"] = this.rpoId;
        data["upi"] = this.upi;
        data["contractorName"] = this.contractorName;
        data["contractorAddress"] = this.contractorAddress;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["openTimeWeekdays"] = this.openTimeWeekdays;
        data["openTimeSaturday"] = this.openTimeSaturday;
        data["openTimeSunday"] = this.openTimeSunday;
        data["isManualPoint"] = this.isManualPoint;
        data["isAutomaticPoint"] = this.isAutomaticPoint;
        return data;
    }
}

export interface IDrsPointDto {
    id: number;
    name?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    normalizedPhoneNumber?: string | undefined;
    webSiteUrl?: string | undefined;
    rpoId?: string | undefined;
    upi?: string | undefined;
    contractorName?: string | undefined;
    contractorAddress?: string | undefined;
    coordinates?: Coordinate | undefined;
    openTimeWeekdays?: string | undefined;
    openTimeSaturday?: string | undefined;
    openTimeSunday?: string | undefined;
    isManualPoint: boolean;
    isAutomaticPoint: boolean;
}

export class CustomerServicePointDto implements ICustomerServicePointDto {
    id!: number;
    customerServicePointType!: string;
    name?: string | undefined;
    addressCounty?: string | undefined;
    addressCity?: string | undefined;
    addressStreetName?: string | undefined;
    addressStreetType?: string | undefined;
    addressZipCode?: string | undefined;
    addressHouseNumber?: string | undefined;
    addressBuilding?: string | undefined;
    addressStaircase?: string | undefined;
    addressFloor?: string | undefined;
    addressDoor?: string | undefined;
    addressHrsz?: string | undefined;
    coordinates?: Coordinate | undefined;
    mailAddressCounty?: string | undefined;
    mailAddressCity?: string | undefined;
    mailAddressStreetName?: string | undefined;
    mailAddressStreetType?: string | undefined;
    mailAddressZipCode?: string | undefined;
    mailAddressHouseNumber?: string | undefined;
    mailAddressBuilding?: string | undefined;
    mailAddressStaircase?: string | undefined;
    mailAddressFloor?: string | undefined;
    mailAddressDoor?: string | undefined;
    mailAddressPostalBox?: string | undefined;
    openHours?: string | undefined;
    openHoursMonday?: string | undefined;
    openHoursTuesday?: string | undefined;
    openHoursWednesday?: string | undefined;
    openHoursThursday?: string | undefined;
    openHoursFriday?: string | undefined;
    openHoursSaturday?: string | undefined;
    openHoursSunday?: string | undefined;
    creditCardPayment!: boolean;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    normalizedPhoneNumber?: string | undefined;
    handleCaseTypes!: boolean;
    comment?: string | undefined;
    isActive!: boolean;

    constructor(data?: ICustomerServicePointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerServicePointType = _data["customerServicePointType"];
            this.name = _data["name"];
            this.addressCounty = _data["addressCounty"];
            this.addressCity = _data["addressCity"];
            this.addressStreetName = _data["addressStreetName"];
            this.addressStreetType = _data["addressStreetType"];
            this.addressZipCode = _data["addressZipCode"];
            this.addressHouseNumber = _data["addressHouseNumber"];
            this.addressBuilding = _data["addressBuilding"];
            this.addressStaircase = _data["addressStaircase"];
            this.addressFloor = _data["addressFloor"];
            this.addressDoor = _data["addressDoor"];
            this.addressHrsz = _data["addressHrsz"];
            this.coordinates = _data["coordinates"] ? Coordinate.fromJS(_data["coordinates"]) : <any>undefined;
            this.mailAddressCounty = _data["mailAddressCounty"];
            this.mailAddressCity = _data["mailAddressCity"];
            this.mailAddressStreetName = _data["mailAddressStreetName"];
            this.mailAddressStreetType = _data["mailAddressStreetType"];
            this.mailAddressZipCode = _data["mailAddressZipCode"];
            this.mailAddressHouseNumber = _data["mailAddressHouseNumber"];
            this.mailAddressBuilding = _data["mailAddressBuilding"];
            this.mailAddressStaircase = _data["mailAddressStaircase"];
            this.mailAddressFloor = _data["mailAddressFloor"];
            this.mailAddressDoor = _data["mailAddressDoor"];
            this.mailAddressPostalBox = _data["mailAddressPostalBox"];
            this.openHours = _data["openHours"];
            this.openHoursMonday = _data["openHoursMonday"];
            this.openHoursTuesday = _data["openHoursTuesday"];
            this.openHoursWednesday = _data["openHoursWednesday"];
            this.openHoursThursday = _data["openHoursThursday"];
            this.openHoursFriday = _data["openHoursFriday"];
            this.openHoursSaturday = _data["openHoursSaturday"];
            this.openHoursSunday = _data["openHoursSunday"];
            this.creditCardPayment = _data["creditCardPayment"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.normalizedPhoneNumber = _data["normalizedPhoneNumber"];
            this.handleCaseTypes = _data["handleCaseTypes"];
            this.comment = _data["comment"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CustomerServicePointDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerServicePointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerServicePointType"] = this.customerServicePointType;
        data["name"] = this.name;
        data["addressCounty"] = this.addressCounty;
        data["addressCity"] = this.addressCity;
        data["addressStreetName"] = this.addressStreetName;
        data["addressStreetType"] = this.addressStreetType;
        data["addressZipCode"] = this.addressZipCode;
        data["addressHouseNumber"] = this.addressHouseNumber;
        data["addressBuilding"] = this.addressBuilding;
        data["addressStaircase"] = this.addressStaircase;
        data["addressFloor"] = this.addressFloor;
        data["addressDoor"] = this.addressDoor;
        data["addressHrsz"] = this.addressHrsz;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["mailAddressCounty"] = this.mailAddressCounty;
        data["mailAddressCity"] = this.mailAddressCity;
        data["mailAddressStreetName"] = this.mailAddressStreetName;
        data["mailAddressStreetType"] = this.mailAddressStreetType;
        data["mailAddressZipCode"] = this.mailAddressZipCode;
        data["mailAddressHouseNumber"] = this.mailAddressHouseNumber;
        data["mailAddressBuilding"] = this.mailAddressBuilding;
        data["mailAddressStaircase"] = this.mailAddressStaircase;
        data["mailAddressFloor"] = this.mailAddressFloor;
        data["mailAddressDoor"] = this.mailAddressDoor;
        data["mailAddressPostalBox"] = this.mailAddressPostalBox;
        data["openHours"] = this.openHours;
        data["openHoursMonday"] = this.openHoursMonday;
        data["openHoursTuesday"] = this.openHoursTuesday;
        data["openHoursWednesday"] = this.openHoursWednesday;
        data["openHoursThursday"] = this.openHoursThursday;
        data["openHoursFriday"] = this.openHoursFriday;
        data["openHoursSaturday"] = this.openHoursSaturday;
        data["openHoursSunday"] = this.openHoursSunday;
        data["creditCardPayment"] = this.creditCardPayment;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["normalizedPhoneNumber"] = this.normalizedPhoneNumber;
        data["handleCaseTypes"] = this.handleCaseTypes;
        data["comment"] = this.comment;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICustomerServicePointDto {
    id: number;
    customerServicePointType: string;
    name?: string | undefined;
    addressCounty?: string | undefined;
    addressCity?: string | undefined;
    addressStreetName?: string | undefined;
    addressStreetType?: string | undefined;
    addressZipCode?: string | undefined;
    addressHouseNumber?: string | undefined;
    addressBuilding?: string | undefined;
    addressStaircase?: string | undefined;
    addressFloor?: string | undefined;
    addressDoor?: string | undefined;
    addressHrsz?: string | undefined;
    coordinates?: Coordinate | undefined;
    mailAddressCounty?: string | undefined;
    mailAddressCity?: string | undefined;
    mailAddressStreetName?: string | undefined;
    mailAddressStreetType?: string | undefined;
    mailAddressZipCode?: string | undefined;
    mailAddressHouseNumber?: string | undefined;
    mailAddressBuilding?: string | undefined;
    mailAddressStaircase?: string | undefined;
    mailAddressFloor?: string | undefined;
    mailAddressDoor?: string | undefined;
    mailAddressPostalBox?: string | undefined;
    openHours?: string | undefined;
    openHoursMonday?: string | undefined;
    openHoursTuesday?: string | undefined;
    openHoursWednesday?: string | undefined;
    openHoursThursday?: string | undefined;
    openHoursFriday?: string | undefined;
    openHoursSaturday?: string | undefined;
    openHoursSunday?: string | undefined;
    creditCardPayment: boolean;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    normalizedPhoneNumber?: string | undefined;
    handleCaseTypes: boolean;
    comment?: string | undefined;
    isActive: boolean;
}

export class FeedbackParamsDto implements IFeedbackParamsDto {
    categoryId!: number;
    ratingValue!: number;
    title?: string | undefined;
    text?: string | undefined;
    platformId?: number | undefined;

    constructor(data?: IFeedbackParamsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.ratingValue = _data["ratingValue"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.platformId = _data["platformId"];
        }
    }

    static fromJS(data: any): FeedbackParamsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackParamsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["ratingValue"] = this.ratingValue;
        data["title"] = this.title;
        data["text"] = this.text;
        data["platformId"] = this.platformId;
        return data;
    }
}

export interface IFeedbackParamsDto {
    categoryId: number;
    ratingValue: number;
    title?: string | undefined;
    text?: string | undefined;
    platformId?: number | undefined;
}

export class FeedbackCategoryDto implements IFeedbackCategoryDto {
    id!: number;
    name!: string;

    constructor(data?: IFeedbackCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FeedbackCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IFeedbackCategoryDto {
    id: number;
    name: string;
}

export class TranslationsDto implements ITranslationsDto {
    translations?: TranslationDto[] | undefined;
    supportedLanguages?: LanguageDto[] | undefined;

    constructor(data?: ITranslationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(TranslationDto.fromJS(item));
            }
            if (Array.isArray(_data["supportedLanguages"])) {
                this.supportedLanguages = [] as any;
                for (let item of _data["supportedLanguages"])
                    this.supportedLanguages!.push(LanguageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TranslationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (Array.isArray(this.supportedLanguages)) {
            data["supportedLanguages"] = [];
            for (let item of this.supportedLanguages)
                data["supportedLanguages"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITranslationsDto {
    translations?: TranslationDto[] | undefined;
    supportedLanguages?: LanguageDto[] | undefined;
}

export class TranslationDto implements ITranslationDto {
    language?: string | undefined;
    key?: string | undefined;
    text?: string | undefined;
    description?: string | undefined;
    parametersCount!: number;
    id?: string | undefined;

    constructor(data?: ITranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.key = _data["key"];
            this.text = _data["text"];
            this.description = _data["description"];
            this.parametersCount = _data["parametersCount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["key"] = this.key;
        data["text"] = this.text;
        data["description"] = this.description;
        data["parametersCount"] = this.parametersCount;
        data["id"] = this.id;
        return data;
    }
}

export interface ITranslationDto {
    language?: string | undefined;
    key?: string | undefined;
    text?: string | undefined;
    description?: string | undefined;
    parametersCount: number;
    id?: string | undefined;
}

export class LanguageDto implements ILanguageDto {
    name?: string | undefined;
    dateFormat?: string | undefined;
    dateTimeFormat?: string | undefined;
    dateTimeFullStringFormat?: string | undefined;
    longTimeStringFormat?: string | undefined;
    decimalSeparator!: string;

    constructor(data?: ILanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.dateFormat = _data["dateFormat"];
            this.dateTimeFormat = _data["dateTimeFormat"];
            this.dateTimeFullStringFormat = _data["dateTimeFullStringFormat"];
            this.longTimeStringFormat = _data["longTimeStringFormat"];
            this.decimalSeparator = _data["decimalSeparator"];
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dateFormat"] = this.dateFormat;
        data["dateTimeFormat"] = this.dateTimeFormat;
        data["dateTimeFullStringFormat"] = this.dateTimeFullStringFormat;
        data["longTimeStringFormat"] = this.longTimeStringFormat;
        data["decimalSeparator"] = this.decimalSeparator;
        return data;
    }
}

export interface ILanguageDto {
    name?: string | undefined;
    dateFormat?: string | undefined;
    dateTimeFormat?: string | undefined;
    dateTimeFullStringFormat?: string | undefined;
    longTimeStringFormat?: string | undefined;
    decimalSeparator: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}